<template>
  <div>LogOut</div>
</template>

<script>
export default {
  name: 'Logout',
  mounted() {
    localStorage.removeItem('token');
    localStorage.removeItem('profile');
    this.$router.push({ name: 'Login' });
  },
};
</script>
